import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Categories() {
  return (
    <section className="bg-background-100 border-y border-background-200/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-semibold text-accent-600">
              <i className="ri-grid-fill"></i> 题材分类
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">海量分类，总能找到喜欢的</h2>
            <p className="mt-2 text-sm text-foreground-500">按题材浏览原版漫画，快速定位你的心头好</p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/comics?category=${c.id}`}
              className="group flex flex-col items-center rounded-xl bg-background-50 p-6 text-center ring-1 ring-background-300/40 transition-all hover:-translate-y-1 hover:ring-primary-500/50"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-500/15 text-primary-500 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 text-sm font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-500">{c.desc}</p>
              <span className="mt-3 rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900 whitespace-nowrap">
                {c.count} 部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}